import { Box, Container, Stack } from "@chakra-ui/react";
import React from "react";

/**
 * Centred single-column shell for the unauthenticated pages (login,
 * subscribe). Deliberately no footer: the legal links live in the app's
 * settings ("Support & Legal") rather than under every unauth form.
 */
export function UnauthLayout({ children }: React.PropsWithChildren) {
  return (
    <Box height={"100vh"}>
      <Container height={"100%"} maxW="400px">
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          height={"100%"}
        >
          {children}
        </Stack>
      </Container>
    </Box>
  );
}
